module.exports = __webpack_public_path__ + "img/Latvia.51fd82ae.svg";